import React from 'react';
import clsx from 'clsx';

export const InfoCircleFilledIcon = ({
  width,
  height,
  fill,
  className,
  ...rest
}) => {
  return (
    <svg
      viewBox='64 64 896 896'
      focusable='false'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      className={clsx('icon', 'icon-info-circle-filled', className)}
      {...rest}
    >
      <path
        d='M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z'
        fill={fill}
      />
    </svg>
  );
};

InfoCircleFilledIcon.defaultProps = {
  width: 17,
  height: 17,
  fill: 'currentColor',
  className: ''
};
